import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { format } from 'date-fns';

const MODERN_COLORS = {
  text: '#111827',
  textSecondary: '#6B7280',
  userBubble: '#111827',
  botBubble: '#F3F4F6',
  userText: '#FFFFFF',
  botText: '#111827',
};

interface Message {
  id: string;
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
}

interface SimpleChatMessageProps {
  message: Message;
}

export const SimpleChatMessage: React.FC<SimpleChatMessageProps> = ({ message }) => {
  const isUser = message.sender === 'user';

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      style={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
      }}
    >
      <Box
        sx={{
          maxWidth: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isUser ? 'flex-end' : 'flex-start',
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderRadius: 2,
            bgcolor: isUser ? MODERN_COLORS.userBubble : MODERN_COLORS.botBubble,
            color: isUser ? MODERN_COLORS.userText : MODERN_COLORS.botText,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '15px',
              lineHeight: 1.5,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {message.text}
          </Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            px: 0.5,
            color: MODERN_COLORS.textSecondary,
            fontSize: '12px',
          }}
        >
          {format(message.timestamp, 'HH:mm')}
        </Typography>
      </Box>
    </motion.div>
  );
};